import { configureStore } from "@reduxjs/toolkit";
import snackbarReducer from "./snackbarSlice";
import confirmSnackbarReducer from "./confirmSnackbarSlice";

const store = configureStore({
  reducer: {
    snackbar: snackbarReducer,
    confirmSnackbar: confirmSnackbarReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
